import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-select/dist/css/bootstrap-select.css'
import $ from 'jquery'
import 'feather-icons'
window.jQuery = $;
import 'bootstrap'
import 'bootstrap-select'

// TODO: move to css bundle
import './css/dashboard.css'
import './css/bootstrap-select-button.css'
import './css/add-button.css'
import './css/upload-images.css'

import { Client } from './client';
import { readConfigFromAPI } from './env-config-reader';
import ApiClient from '../lib/apiClient';
import FilesClient from '../lib/filesClient';
import AuthClient from '../lib/authClient';

async function main() {
    const config = await readConfigFromAPI();
    const apiClient = new ApiClient(config.apiHostPublic);
    const filesClient = new FilesClient(config.apiHostPublic, config.staticDownloadPath);
    const authClient = new AuthClient(config.apiHostPublic);
    console.log('Config:', JSON.stringify(config, null, 4));
    const client = new Client($, apiClient, filesClient, authClient);
    client.initialize();
}

$(document).ready(() => {
    main();
});
